import { lazy, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useUserData } from "src/context/userContext";

import { attachment_get } from "../attachments/AttachmentFunctions";
import ProgressCirc from "../layout/Progress/ProgressCirc";
import LazyLoader from "../layout/Progress/LazyLoader";

const Attachment_PdfViewer = lazy(() => import("./Attachment_PdfViewer"));
const Attachment_ImageViewer = lazy(() => import("./Attachment_ImageViewer"));

export default function AttachmentViewer({ attachmentId }) {
  const { token } = useUserData();
  const [attachment, setAttachment] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!attachmentId) {
      if (attachment) setAttachment(null);
      return;
    }
    const asynk = async () => {
      setIsLoading(true);
      const a = await attachment_get(attachmentId, token);
      if (a === false) {
        setIsLoading(false);
        setIsError(true);
        setAttachment(null);
        return;
      }
      setAttachment(a);
      setIsLoading(false);
    };
    asynk();
  }, [attachmentId, token]);

  if (!attachmentId) return null;
  if (!attachment) return null;
  if (!attachment.fileType) return "";

  return (
    <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
      {isLoading || isError ? (
        <div style={{ padding: 50 }}>
          {isLoading ? <ProgressCirc open size={50} /> : <div>Virhe ladattaessa liitettä</div>}
        </div>
      ) : (
        <LazyLoader>
          {attachment && attachment.fileType.includes("pdf") ? (
            <Attachment_PdfViewer url={attachment?.blobUrl} />
          ) : (
            <Attachment_ImageViewer url={attachment?.blobUrl} />
          )}
        </LazyLoader>
      )}
    </div>
  );
}

AttachmentViewer.propTypes = {
  attachmentId: PropTypes.number,
};
